{
  "embedded.layout.title": "Tickets",
  "embedded.layout.openStandalone": "Open full workspace",
  "embedded.tickets.tabs.all": "All tickets",
  "embedded.tickets.tabs.assigned": "Assigned to me",
  "embedded.tickets.tabs.participating": "Collaborating on",
  "embedded.connecting.title": "Connecting to the host",
  "embedded.connecting.detail": "Waiting for the host application to establish the secure channel.",
  "embedded.waitingToken.title": "Waiting for credentials",
  "embedded.waitingToken.detail": "The host application is issuing the access credential for this session.",
  "embedded.handshakeFailed.title": "Cannot reach the host application",
  "embedded.handshakeFailed.detail": "The host did not answer the handshake. Reload the host page; if it keeps failing, ask an administrator to check the embedding configuration.",
  "embedded.invalidConfig.title": "Invalid host configuration",
  "embedded.invalidConfig.detail": "Host origins were configured, but none are valid. Ask an administrator to check the embedding configuration.",
  "embedded.notEmbedded.title": "This page only runs inside a host application",
  "embedded.notEmbedded.detail": "Open the full workbench instead of loading this address directly.",
  "embedded.sessionEnded.title": "The session has ended",
  "embedded.sessionEnded.detail": "The host application signed out. Sign in again there to reopen tickets.",
  "embedded.sessionEnded.unauthorized": "The credential is no longer accepted. Reload the host page to start a new session.",
  "embedded.accessDenied.title": "No access to this item",
  "embedded.accessDenied.detail": "Your Tickbird permissions do not cover this ticket. Contact a Tickbird administrator if you need access.",
  "embedded.context.title": "Business context",
  "embedded.context.systemCode": "System",
  "embedded.context.entityType": "Object type",
  "embedded.context.entityId": "Object ID",
  "embedded.context.waiting": "The host has not sent a business context yet.",
  "embedded.context.providerPending": "Related tickets are not available yet: the server-side integration adapter that resolves this business object has not been implemented.",
  "embedded.ticketDetail.title": "Ticket",
  "embedded.ticketDetail.back": "Back to related tickets",
  "embedded.newTicket.title": "New ticket",
  "embedded.newTicket.projectMissing": "The host has not configured a ticket project. Ask your administrator to set projectCode in the embedding configuration.",
  "embedded.pagePending": "This page is a scaffold. The shared ticket feature blocks still have to be moved into the shared feature layer."
}
